
function isInGroup (userGroups, requiredGroup) {
  if (typeof requiredGroup === 'string') {
    return userGroups
      .map(m => m.displayName)
      .filter(f => f.indexOf(requiredGroup) > -1)
      .length > 0
  }

  // check array
  return userGroups
    .map(m => m.displayName)
    .filter(ug => requiredGroup.filter(rg => ug.indexOf(rg) > -1).length > 0)
    .length > 0
}

export default isInGroup
